import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import styles from './BottomNav.module.css';

const BottomNav: React.FC = () => {
    const location = useLocation();
    const hash = location.hash;

    const isHome = location.pathname === '/' && !hash;
    const isRoute = (path: string) => {
        if (path === '/') return location.pathname === '/';
        return location.pathname.startsWith(path);
    };

    const isHash = (target: string) => location.pathname === '/' && hash === target;

    return (
        <nav className={styles.nav} aria-label="মোবাইল নেভিগেশন">
            <Link to="/" className={`${styles.item} ${isHome ? styles.active : ''}`}>
                <span className={styles.icon} aria-hidden="true">🏠</span>
                <span>হোম</span>
            </Link>
            <Link to="/events" className={`${styles.item} ${isRoute('/events') ? styles.active : ''}`}>
                <span className={styles.icon} aria-hidden="true">📋</span>
                <span>সব ম্যাচ</span>
            </Link>
            <Link to={{ pathname: '/', hash: '#live' }} className={`${styles.item} ${isHash('#live') ? styles.active : ''}`}>
                <span className={styles.icon} aria-hidden="true">🔴</span>
                <span>লাইভ</span>
            </Link>
            <Link to={{ pathname: '/', hash: '#about' }} className={`${styles.item} ${isHash('#about') ? styles.active : ''}`}>
                <span className={styles.icon} aria-hidden="true">ℹ️</span>
                <span>সম্পর্কে</span>
            </Link>
        </nav>
    );
};

export default BottomNav;
